import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import axios from 'axios';
import './Stylists.css';

const stylistColors = [
  'linear-gradient(135deg, #c9a96e, #e8c5cb)',
  'linear-gradient(135deg, #a07840, #c9a96e)',
  'linear-gradient(135deg, #e8c5cb, #c9a96e)',
];

const stylistInitials = (name) =>
  name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();

export default function Stylists() {
  const [stylists, setStylists] = useState([]);

  useEffect(() => {
    axios.get('/api/stylists').then(r => setStylists(r.data)).catch(() => {});
  }, []);

  return (
    <section id="stylists" className="stylists-section">
      <div className="stylists-container">
        <div className="section-header">
          <span className="section-eyebrow">Nossa Equipe</span>
          <h2 className="section-title">
            {stylists.length === 1
              ? 'Nossa Profissional'
              : `Nossas ${stylists.length} Profissionais`}
          </h2>
          <div className="gold-line" />
          <p className="section-subtitle">
            Conheça {stylists.length === 1 ? 'a talentosa profissional' : 'as talentosas profissionais'} que {stylists.length === 1 ? 'irá' : 'irão'} cuidar de você
          </p>
        </div>

        <div className="stylists-grid">
          {stylists.map((stylist, idx) => (
            <div key={stylist.id} className="stylist-card">
              <div className="stylist-avatar-wrap">
                {stylist.photo ? (
                  <img
                    src={`/uploads/${stylist.photo}`}
                    alt={stylist.name}
                    className="stylist-avatar"
                    style={{ objectFit: 'cover' }}
                    onError={e => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                ) : null}
                <div
                  className="stylist-avatar"
                  style={{
                    background: stylistColors[idx % stylistColors.length],
                    display: stylist.photo ? 'none' : 'flex',
                  }}
                >
                  {stylistInitials(stylist.name)}
                </div>
                <div className="stylist-badge">
                  <Star size={12} fill="#c9a96e" color="#c9a96e" />
                  <span>Pro</span>
                </div>
              </div>
              <div className="stylist-info">
                <h3 className="stylist-name">{stylist.name}</h3>
                <span className="stylist-specialty">{stylist.specialty}</span>
                <p className="stylist-bio">{stylist.bio}</p>
                <Link
                  to={`/reservar?stylist=${stylist.id}`}
                  className="stylist-book-btn"
                >
                  Agendar com {stylist.name.split(' ')[0]}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
